import React, { forwardRef, ReactElement } from 'react';
import styled from 'styled-components/macro';
import cx from 'classnames';
import { Props as TabProps } from './Tab';

type Props = {
  className?: string;
  inline?: boolean;
  flat?: boolean;
  children: ReactElement<TabProps>[] | ReactElement<TabProps>;
};

export const Tabs = forwardRef((props: Props, ref: StyledRef<HTMLDivElement>) => {
  const { children, className, inline, flat } = props;
  return (
    <TabsWrapper ref={ref} className={cx('tabs man-ui', { inline }, flat ? 'flat' : 'full', className)}>
      {children}
    </TabsWrapper>
  );
});

Tabs.displayName = 'Tabs';

const TabsWrapper = styled.div`
  background-color: rgb(245, 245, 245);

  &.full {
    border-bottom: 1px solid rgb(215, 215, 215);

    .tab {
      margin-bottom: -1px;

      &.active {
        border: 1px solid #ddd;
        background-color: rgb(255, 255, 255);
        border-bottom: 0;
      }

      &.hover {
        border-bottom-color: rgb(215, 215, 215);
      }
    }
  }

  &.flat {
    .tab {
      &.active {
        background-color: #d7d7d7;
      }
    }
  }

  &.inline {
    display: inline-block;
  }

  .tab {
    display: inline-block;
    padding: 15px 22px;
    font-size: 1rem;
    text-decoration: none;
    border-radius: 0;
    margin-right: 0;
    cursor: pointer;
    color: #000;
    vertical-align: top;

    &.disabled,
    &.active {
      cursor: default;
    }

    @media (max-width: 767px) {
      padding: 7px 22px;
    }

    @media (max-width: 479px) {
      font-weight: 400;
    }

    &:hover {
      background-color: #d7d7d7;
      border-color: transparent;
    }
  }
`;
